import React from 'react';
import { MessageCircle, ShoppingCart } from 'lucide-react';
import { useCart } from '@/store/Layout/product/CartContext';
import {
  ButtonWrapper,
  Button,
  DropdownIcon,
  MobileMenu as MobileMenuStyled,
  MobileSubmenu,
  MobileSubmenuGroup,
  MobileSubmenuHeading,
  SubItem,
  QuickActionWrapper,
  QuickActionButton,
  QuickActionBadge,
} from './styled';

const MobileMenu = ({
  navSections,
  openSubmenu,
  isSectionActive,
  handleSectionClick,
  handleSubItemClick,
  newSections,
  onIconClick,
  unreadMessages,
}) => {
  const { cartCount } = useCart();
  
  return (
    <MobileMenuStyled>
      <QuickActionWrapper>
        <QuickActionButton
          type="button"
          onClick={() => onIconClick('chat')}
        >
          <MessageCircle size={20} strokeWidth={2} />
          <span>Live Chat</span>
          {unreadMessages > 0 && (
            <QuickActionBadge>{unreadMessages}</QuickActionBadge>
          )}
        </QuickActionButton>
        <QuickActionButton
          type="button"
          onClick={() => onIconClick('cart')}
        >
          <ShoppingCart size={20} strokeWidth={2} />
          <span>Cart</span>
          {cartCount > 0 && (
            <QuickActionBadge>{cartCount}</QuickActionBadge>
          )}
        </QuickActionButton>
      </QuickActionWrapper>
      {navSections.map(section => {
      const sectionActive = isSectionActive(section);
      const hasSubmenu = Array.isArray(section.submenus) && section.submenus.length > 0;
      const isExpanded = openSubmenu === section.label;
      return (
        <ButtonWrapper key={`mobile-${section.label}`}>
          <Button
            type="button"
            active={sectionActive}
            onClick={() => handleSectionClick(section)}
            aria-haspopup={hasSubmenu ? 'true' : undefined}
            aria-expanded={hasSubmenu ? isExpanded : undefined}
          >
            {section.label}
            {hasSubmenu && (
              <DropdownIcon size={14} strokeWidth={2} $expanded={isExpanded} />
            )}
          </Button>
          {newSections[section.label] && ['OTC', 'Trade', 'Project', 'Marketplace'].includes(section.label) && (
            <div style={{
              position: 'absolute',
              top: '-2px',
              right: '-2px',
              background: '#00f7d2',
              color: '#001018',
              fontWeight: 700,
              fontSize: '0.45rem',
              padding: '0 3px',
              borderRadius: '999px',
            }}>
              NEW
            </div>
          )}
          {hasSubmenu && isExpanded && (
            <MobileSubmenu>
              {section.submenus.map((group, index) => (
                <MobileSubmenuGroup key={`mobile-${section.label}-group-${index}`}>
                  {group.title && <MobileSubmenuHeading>{group.title}</MobileSubmenuHeading>}
                  {group.items.map(item => (
                    <SubItem
                      key={`mobile-${section.label}-${item.path}`}
                      type="button"
                      onClick={() => handleSubItemClick(item, section.label)}
                    >
                      {item.label}
                    </SubItem>
                  ))}
                </MobileSubmenuGroup>
              ))}
            </MobileSubmenu>
          )}
        </ButtonWrapper>
      );
    })}
    </MobileMenuStyled>
  );
};

export default MobileMenu;

